'use strict';

require('jquery');
require('bower/bootstrap-datepicker/dist/css/bootstrap-datepicker.css');
require('bootstrap-tagsinput-css');
require('bootstrap-timepicker-css');

var enquire = require('enquire');

var app = require('system.app');

//Media queries
var screen = 'screen and ',
    max_sm = '(max-width:767px)',
    max_md = '(max-width:992px)';

app.plugins.configure({
    '.status': [
        function ($elements) {
            $elements.each(function () {
                $(this).status();
            });
        },
        null
    ],
    '.block-fh': [
        function ($elements) {
            $('body').addClass('page-split');

            enquire.register(screen + max_sm, {
                match: function () {
                    $('body').removeClass('page-split');
                },
                unmatch: function () {
                    $('body').addClass('page-split');
                }
            });

            function full_blocks() {
                var header = $('#header').outerHeight();
                var tb = $('#toolbar').outerHeight();
                var footer = $('#footer').outerHeight();
                var offset = header + tb + footer + 93;
                $elements.css('height', $(window).height() - offset);
            }

            full_blocks();

            $(window).resize(function () {
                full_blocks();
            });
        },
        function ($elements) {
            $('body').removeClass('page-split');
        }
    ],
    '.block-scroll': [
        function ($elements) {
            require([
                'perfect-scrollbar-css',
                'app/module/Application/css/override/perfect-scrollbar.css',
                'perfect-scrollbar',
            ], function () {
                $elements.perfectScrollbar();
                $(window).resize(function () {
                    $elements.perfectScrollbar('update');
                });
            });
        },
        function ($elements) {
            $elements.perfectScrollbar('destroy');
        }
    ],
    '.table-fixed-header': [
        function ($elements) {
            require(['jquery.floatThead'], function () {
                $elements.floatThead({
                    zIndex: 101,
                    position: 'absolute'
                });
            });
        },
        function ($elements) {
            $elements.floatThead('destroy');
        }],
    // Tabs components
    'a[data-toggle="tab"]': [
        function ($elements) {
            $elements.on('shown.bs.tab', function (e) {
                var $target = $($(e.target).attr('href'));

                if ($target.data('content')) {
                    $target.loadContent();
                } else {
                    // activate remote components
                    app.component.load($target);
                }
            });
        },
        null
    ],
    '[data-toggle="tooltip"]': [
        function ($elements) {
            $elements.each(function (i, el) {
                $(el).tooltip({
                    trigger: 'hover',
                    container: 'body',
                    delay: {'show': 200},
                    placement: $(this).data('placement') || 'auto top'
                });
            });
        },
        function ($elements) {

        }
    ],
    '.dropdown:not(.bootstrap-select), .btn-group:not(.bootstrap-select)': [
        function ($elements) {
            // Dropdown animations
            $elements.on('show.bs.dropdown', function () {
                var $this = $(this);

                $this.children('.dropdown-animated').removeClass('closed').show().addClass('opened');
                //- Dropscroll max height
                var maxItems = $this.find('.dropscroll').data('max-items');
                var liHeight = $this.find('.menu-items > li').height();
                $this.find('.dropscroll').css('max-height', maxItems * liHeight + 'px');

                /*require(['mCustomScrollbar', 'mouseWheel'], function () {
                 $this.find('.dropscroll').mCustomScrollbar({
                 theme: 'minimal-dark',
                 scrollInertia: 300,
                 mouseWheel: {
                 enable: true,
                 preventDefault: true
                 },
                 callbacks: {
                 onInit: function () {
                 
                 }
                 }
                 });
                 });*/
            });
            $elements.on('shown.bs.dropdown', function () {
                var $this = $(this);

                //- Auto dropup
                var windowHeight = $(window).height();
                var rect = $this.get(0).getBoundingClientRect();
                if (rect.top > windowHeight)
                    return;
                var menuHeight = $this.children('.dropdown-menu').height();

                $this.toggleClass('dropup',
                    ((windowHeight - rect.bottom) < menuHeight) &&
                    (rect.top > menuHeight));
            });
            $elements.on('hide.bs.dropdown', function () {
                var $this = $(this);
                //if (!$(this).find('.dropdown-menu').hasClass('dropdown-visible')) {
                $(this).children('.dropdown-animated').removeClass('opened').addClass('closed');

                setTimeout(function () {
                    $this.children('.dropdown-animated').hide(function () {
                        //$this.find('.dropscroll').mCustomScrollbar('destroy');
                    });
                }, 300);
            });

            $elements.find('.dropdown-clickable input, .dropdown-clickable label').click(function (e) {
                e.stopPropagation();
            });

            /*$(window).on('scroll resize', function () {
             $('.dropdown.open').dropdown('toggle');
             });*/
        },
        null
    ],
    '.xedit': [
        function ($elements) {
            require([
                'bower/x-editable/dist/bootstrap3-editable/css/bootstrap-editable.css',
                'app/module/Application/css/override/x-editable.css',
                'jquery',
                'moment',
                'x-editable',
                'bower/bootstrap-datepicker/js/locales/bootstrap-datepicker.sk'
            ], function () {
                $elements.each(function (i, el) {
                    var $el = $(el),
                        originalText = $el.text();

                    $el.editable({
                        datepicker: {
                            language: 'sk',
                            weekStart: 1
                        },
                        url: function (params) {
                            var d = new $.Deferred();
                            var data = {};

                            data[params.name] = params.value;
                            data['ID'] = params.pk;

                            app.http.post('/audit/processing/update', data).then(function () {
                                d.resolve();
                                originalText = $el.text(); // replace original text with new saved

                                if ($el.data('eventbus')) {
                                    app.component.eventBus.get().group($el.data('eventbus')['group']).emit($el.data('eventbus')['method']);
                                }

                            }).catch(function (err) {
                                d.reject(err);
                                $el.editable('setValue', originalText); // return to original value
                            });
                        }
                    });
                });
            });
        }
    ],
    '.modal': [
        function ($elements) {
            $elements.on('show.bs.modal', function (e) {
                //var $dialog = $(this).find();
            });
        }
    ],
    '.bootstrap-select': [
        function ($elements) {
            require(['bower/bootstrap-select/dist/css/bootstrap-select.css', 'bootstrap-select'], function () {
                $.fn.selectpicker.defaults = {
                    noneSelectedText: 'Vyberte zo zoznamu',
                    noneResultsText: 'Žiadne výsledky pre: {0}',
                    countSelectedText: 'Vybrané {0} z {1}',
                    maxOptionsText: ['Limit prekročený ({n} {var} max)', 'Limit skupiny prekročený ({n} {var} max)', ['položiek', 'položka']],
                    selectAllText: 'Vybrať všetky',
                    deselectAllText: 'Zrušiť výber',
                    multipleSeparator: ', '
                };

                $elements.selectpicker({
                    style: 'btn-default',
                    liveSearch: true,
                    liveSearchPlaceholder: 'Rýchle hľadanie',
                    size: 6
                });

                $elements.on('reset', function () {
                    $(this).selectpicker('deselectAll');
                });
            });
        },
        function ($elements) {
            $elements.selectpicker('destroy');
        }
    ],
    '.date-range': [
        function ($elements) {
            require(['moment', 'bower/bootstrap-daterangepicker/daterangepicker.css', 'daterangepicker'], function (moment) {
                $elements.each(function () {
                    var $this = $(this);

                    $this.daterangepicker({
                        locale: {
                            format: 'DD.MM.YYYY',
                            cancelLabel: 'Vymazať',
                            applyLabel: 'Použiť',
                            fromLabel: 'Od',
                            toLabel: 'Do',
                            customRangeLabel: 'Vlastný rozsah',
                            daysOfWeek: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
                            monthNames: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
                            firstDay: 1
                        },
                        ranges: {
                            'Dnes': [moment(), moment()],
                            'Včera': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Posledných 7 dní': [moment().subtract(7, 'days'), moment()],
                            'Posledných 14 dní': [moment().subtract(14, 'days'), moment()],
                            'Tento mesiac': [moment().startOf('month'), moment().endOf('month')],
                            'Minulý mesiac': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                        },
                        autoApply: true,
                        autoUpdateInput: false,
                    });

                    $this.on('cancel.daterangepicker', function (ev, picker) {
                        $(this).val('');
                    });

                    $this.on('apply.daterangepicker', function (ev, picker) {
                        $(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
                    });

                });
            });
        },
        function ($elements) {
            $elements.data('daterangepicker').remove();
        }
    ],
    '.date-simple': [
        function ($elements) {
            require(['bootstrap-datepicker'], function () {

                $.fn.datepicker.dates['sk'] = {
                    days: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
                    daysShort: ["Ned", "Pod", "Uto", "Str", "Štv", "Pia", "Sob"],
                    daysMin: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
                    months: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
                    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
                    today: "Dnes",
                    clear: "Zmazať",
                    format: "dd.mm.yyyy",
                    titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
                    weekStart: 1
                };

                $elements.each(function () {
                    var $el = $(this);

                    $el.datepicker({
                        format: 'dd.mm.yyyy',
                        todayBtn: "linked",
                        keyboardNavigation: false,
                        forceParse: false,
                        calendarWeeks: true,
                        autoclose: true,
                        language: 'sk'
                    }).on('changeDate', function (e) {
                        // trigger change to apply validator
                        $el.valid();
                    });
                });
            });
        },
        function ($elements) {
            $elements.datepicker('remove');
        }
    ],
    '.mask': [
        function ($elements) {
            require(['masked-input'], function () {
                $elements.each(function () {
                    var $this = $(this);

                    $this.mask($this.data('mask').toString());
                });
            });
        },
        function ($elements) {
            $elements.each(function () {
                $(this).unmask();
            });
        }
    ],
    '.ieditable': [
        function ($elements) {
            $elements.each(function () {
                $(this).ieditable();
            });
        }
    ],
    '[data-toggle="popover"]': [
        function ($elements) {
            $elements.popover({
                container: 'body',
                placement: 'auto top'
            });

            $elements.on('click', function (e) {
                e.preventDefault();
                return true;
            }); // prevent scroll up after click
        },
        function ($elements) {

        }
    ],
    'input[data-role=tagsinput], select[multiple][data-role=tagsinput]': [
        function ($elements) {
            require(['bootstrap-tagsinput'], function () {
                $elements.tagsinput();
            });

        },
        function ($elements) {

        }
    ],
    // Custom Checkboxes
    '.icheck': [
        function ($elements) {
            require(['bower/iCheck/skins/square/green.css', 'iCheck'], function () {
                $elements.iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green',
                    increaseArea: '20%' // optional
                }).on('ifChecked', function (event) {
                    $(event.target).trigger('input');
                }).on('ifUnchecked', function (event) {
                    $(event.target).trigger('input');
                });
            });
        },
        function ($elements) {
            $elements.iCheck('destroy');
        }],
    '.table-collapsible': [
        function ($elements) {
            $elements.each(function () {
                var $this = $(this),
                    row = $this.find('tbody > tr'),
                    exp = $this.find('tbody > tr > td:first-child');

                row.each(function (index, value) {
                    var rowLevel = $(this).data('level');
                    var rowGroup = $(this).data('group');
                    if (rowLevel === 0 || rowLevel > 1) {
                        $(this).addClass('hidden');
                    }
                    $(this).addClass('row-level_' + rowLevel);
                    $(this).find('td:first-child').css('padding-left', (rowLevel - 1) * 20);

                    if (rowLevel === 1) {
                        $(this).addClass('start');
                    }
                    if ($(this).next().data('level') < rowLevel) {
                        $(this).addClass('end');
                    }
                    if (rowGroup % 2 !== 0) {
                        $(this).addClass('odd');
                    }
                });
                exp.not('.table-collapsible tbody > tr.end > td').click(function () {
                    var thisRow = $(this).parent();
                    var currLevel = $(this).parent().data('level');
                    var rowGroup = $(this).parent().data('group');
                    var nextLevel = currLevel + 1;
                    var currRow = $('tr[data-level=' + currLevel + '][data-group=' + rowGroup + ']');
                    var nextRow = $('tr[data-level=' + nextLevel + '][data-group=' + rowGroup + ']');

                    if (thisRow.hasClass('expanded')) {
                        thisRow.nextAll('tr[data-group=' + rowGroup + ']').addClass('hidden').removeClass('expanded');
                        currRow.removeClass('expanded');
                    } else {
                        nextRow.removeClass('hidden');
                        thisRow.addClass('expanded');
                    }
                });
            });
        },
        null
    ],
    '.datetimepicker': [
        function ($elements) {
            require(['datetimepicker-css', 'datetimepicker', 'datetimepicker-locales/bootstrap-datetimepicker.sk.js'], function () {
                $elements.each(function () {
                    var $this = $(this);

                    $this.datetimepicker({
                        format: 'dd.mm.yyyy hh:ii'
                    });

                    $this.on('change.dp', function () {
                        $this.trigger('datetimepicker-change');
                    });
                });
            });
        }
    ],
    '.ext-bootstrap-timepicker': [
        function ($elements) {
            require(['bootstrap-timepicker'], function () {
                $elements.timepicker({
                    showMeridian: false,
                    defaultTime: false,
                    showInputs: false,
                });
            });

        },
        function ($elements) {

        }
    ],
    '.image-preview': [
        function ($elements) {
            $elements.each(function () {
                var $this = $(this);
                var previewId = 'image-preview';
                var xOffset = 10;
                var yOffset = 250;

                $this.hover(function (e) {
                        this.t = this.title;
                        //this.title = "";

                        var c = (this.t != "") ? "<br/>" + this.t : "";
                        $("body").append("<p id='"+previewId+"'><img src='" + this.href + "' alt='Podpis' />" + c + "</p>");

                        $("#" + previewId)
                            .css("top", (e.pageY - xOffset) + "px")
                            .css("left", (e.pageX - yOffset) + "px")
                            .fadeIn("fast");
                    },
                    function () {
                        //this.title = this.t;
                        $("#" + previewId).remove();
                    });

                $this.mousemove(function (e) {
                    $("#" + previewId)
                        .css("top", (e.pageY - xOffset) + "px")
                        .css("left", (e.pageX - yOffset) + "px");
                });
            });
        },
        function ($elements) {

        }
    ],
});

// close bootstrap select list
/*$('body').on('click', function (event) {
 var target = $(event.target);
 if (target.parents('.bootstrap-select').length) {
 target.parents('.bootstrap-select').toggleClass('open');
 event.stopPropagation();
 }
 });*/

$.fn.status = function () {
    var $this = $(this);

    if ($this.data('status')) {
        return;
    }

    $this.data('status', true);

    var $select = $this.find('select'),
        $button = $this.find('button'),
        $ul = $this.find('ul'),
        colorClasses = $this.data('status-colorclasses');

    $ul.on('click', 'li', function () {
        var $li = $(this);

        $button.removeClass(colorClasses).addClass($li.data('status-colorclass'));
        $button.find('.text').text($li.find('a').text());

        $select.val($li.data('status-id')).change();
    });
}

$.fn.status = function () {
    var $this = $(this);

    if ($this.data('status')) {
        return;
    }

    $this.data('status', true);

    var $select = $this.find('select'),
        $button = $this.find('button'),
        $ul = $this.find('ul'),
        colorClasses = $this.data('status-colorclasses');

    $ul.on('click', 'li', function () {
        var $li = $(this);

        $button.removeClass(colorClasses).addClass($li.data('status-colorclass'));
        $button.find('.text').text($li.find('a').text());

        $select.val($li.data('status-id')).change();
    });
}

/*
 * @param {object} options
 * @param {function} options.success call a function if request was sucessfull
 * @param {function} options.error call a function if request was failed
 * @returns {undefined}
 */
$.fn.ieditable = function (options) {
    var $this = $(this);

    if ($this.data('ieditable')) {
        return;
    }

    $this.data('ieditable', true);


    var options = options || {},
        event = 'change',
        url = $this.data('ieditable-url'),
        data = $this.data('ieditable-data') || {};

    if ($this.is('input')) {
        event = 'input';
    }

    if ($this.data('ieditable-event')) {
        event = $this.data('ieditable-event');
    }

    $this.on(event, function () {
        if ($this.attr('type') === 'checkbox' || $this.attr('type') === 'radio') {
            data[$this.attr('name')] = ($this.is(':checked')) ? $this.val() : 0;
        } else {
            // if input add value
            if ($this.is(':input')) {
                data[$this.attr('name')] = $this.val();
            }
        }

        app.http.post(url, data, 'json').then(function (response) {
            if (typeof options.success === 'function') {
                options.success(response);
            }

            if ($this.data('eventbus')) {
                app.component.eventBus.get().group($this.data('eventbus')['group']).emit($this.data('eventbus')['method']);
            }

        }).catch(function (err) {
            if (typeof options.error === 'function') {
                options.error(err);
            }

            // restore back to original value
            $this.val(data[$this.attr('name')]);
        });
    });
}

$.fn.outerHTML = function () {
    var $t = $(this),
        content = $t.wrap('<div></div>').parent().html();
    $t.unwrap();
    return content;
};

$.fn.emptyDelimiter = function () {
    $(this).on('blur', function () {
        var $this = $(this);
        if ($this.val() === '') {
            $this.addClass('hasDelimiter');
        } else {
            $this.removeClass('hasDelimiter');
        }
    });
};
/* END form */